/** The world composition fitted for one device (src/view/logic/worldFit.ts), kept per device key. */
import type { Composition } from '../view/logic/registry';

export interface StoredWorld { composition: Composition; final: boolean }

const KEY = (device: string): string => `megamx.world.${device}`;

/** localStorage, or null where the page may not use it. */
export function storage(): Storage | null {
  try { return localStorage; } catch { return null; }
}

export function loadWorld(store: Storage | null, device: string): StoredWorld | null {
  try { const raw = store?.getItem(KEY(device)); return raw ? (JSON.parse(raw) as StoredWorld) : null; } catch { return null; }
}

export function saveWorld(store: Storage | null, device: string, w: StoredWorld): void {
  try { store?.setItem(KEY(device), JSON.stringify(w)); } catch { /* storage blocked */ }
}

export function clearWorld(store: Storage | null, device: string): void {
  try { store?.removeItem(KEY(device)); } catch { /* storage blocked */ }
}
